export interface InfoBoxProps {
  title: string;
  icon: React.ReactElement;
  children?: React.ReactElement | React.ReactElement[];
}

function InfoBox(props: InfoBoxProps) {
  return (
    <div className="ct_infoBox">
      <div className="ct_infoBox-header">
        <div className="ct_infoBox-icon">
          {props.icon}
        </div>
        <div className="ct_infoBox-title">
          <h2 className="ct_h4">{props.title}</h2>
        </div>
      </div>
      <div className="ct_infoBox-content">
        {props.children}
      </div>
    </div>
  );
}

InfoBox.defaultProps = { ...{} };

export default InfoBox;
